import { type FC } from 'react';
import { motion } from 'framer-motion';

import { filterContractListByKind } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { ActiveSpecContractList } from '../ActiveSpecContractList/ActiveSpecContractList';
import ContractSoonBlock from '../ContractSoon/ContractSoonBlock';
import NextContractInBlock from '../NextContractIn/NextContractInBlock';
import TutorialPremiumContracts from '../TutorialPremiumContracts/TutorialPremiumContracts';

interface SpecialContractsListProps {
  isUninitialized: boolean;
  userLevel: number;
  onlyActive?: boolean;
}

const SpecialContractsList: FC<SpecialContractsListProps> = ({
  isUninitialized,
  userLevel,
  onlyActive,
}) => {
  const contractList = useAppSelector((state) =>
    filterContractListByKind(state, 'Default'),
  );

  return (
    <motion.div
      key="spec-contract-list"
      className="px-8 md-h:pt-4 pt-6 h-[9.5rem] md-h:h-[9rem] overflow-y-hidden flex gap-8 w-max md-h:mb-3 mb-6"
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
    >
      {userLevel > 1 && (
        <TutorialPremiumContracts
          isUninitialized={isUninitialized}
          userLevel={userLevel}
        />
      )}
      <ActiveSpecContractList tab="special" />
      {!onlyActive && <NextContractInBlock />}
      {!onlyActive && (
        <ContractSoonBlock
          contractList={contractList}
          userLevel={userLevel}
          isUninitialized={isUninitialized}
        />
      )}
    </motion.div>
  );
};

export default SpecialContractsList;
